import React from "react";

import { templates } from "@reactivated";

import Flair from "../common/Flair";

export const Template = (
    props: templates.FlairSubBlockTemplate,
): React.ReactNode => (
    <React.StrictMode>
        {props.content && (
            <Flair
                flair={{
                    style: props.style,
                    content: props.content,
                }}
            />
        )}
    </React.StrictMode>
);
